export const kFlattenedConfig = Symbol('report-toolkit-flattened-config');
export const kRedacted = Symbol('report-toolkit-redacted');
export const kReport = Symbol('report-toolkit-report');
export const kReportFilepath = Symbol('report-toolkit-report-filepath');
export const kRuleId = Symbol('report-toolkit-rule-id');
export const kRuleInspect = Symbol('report-toolkit-rule-inspect');
export const kRuleMeta = Symbol('report-toolkit-rule-meta');
